export const singletonSettingsSections = [
  { routeKey: "general", dbKey: "general", label: "General" },
  { routeKey: "pricebook", dbKey: "pricebook", label: "Pricebook" },
  { routeKey: "booking-form", dbKey: "booking_form", label: "Booking Form" },
  { routeKey: "frequency-settings", dbKey: "frequency_settings", label: "Frequency Settings", hidden: true },
  { routeKey: "google-maps-api", dbKey: "google_maps_api", label: "Google Maps API", hidden: true },
  { routeKey: "gift-card-storefront", dbKey: "gift_card_storefront", label: "Gift Card Storefront", hidden: true },
  { routeKey: "invoices", dbKey: "invoices", label: "Invoices" },
  { routeKey: "emails", dbKey: "emails", label: "Emails" },
  { routeKey: "text-messages", dbKey: "text_messages", label: "Text Messages" },
  { routeKey: "waitlist", dbKey: "waitlist", label: "Waitlist" },
  { routeKey: "leads", dbKey: "leads", label: "Leads" },
  { routeKey: "marketing", dbKey: "marketing", label: "Marketing" },
  { routeKey: "other", dbKey: "other", label: "Miscellaneous" }
] as const;

export const relationalSettingsSections = [
  {
    routeKey: "locations",
    table: "locations",
    idPrefix: "loc",
    label: "Locations",
    coreFields: ["name", "timezone", "active"] as const
  },
  {
    routeKey: "services",
    table: "services",
    idPrefix: "svc",
    label: "Services",
    coreFields: ["name", "category", "duration_minutes", "base_price_amount", "active"] as const
  },
  {
    routeKey: "service-scenarios",
    table: "service_scenarios",
    idPrefix: "scenario",
    label: "Service Scenarios",
    coreFields: ["name", "code", "base_service_id", "pricing_mode", "active"] as const
  },
  {
    routeKey: "extras",
    table: "service_options",
    idPrefix: "extra",
    label: "Extras",
    coreFields: ["name", "price_delta_amount", "duration_delta_minutes", "active"] as const
  },
  {
    routeKey: "booking-spots",
    table: "booking_spots",
    idPrefix: "spot",
    label: "Availability",
    coreFields: ["name", "location_id", "capacity", "interval_minutes", "active"] as const
  },
  {
    routeKey: "calendar-profiles",
    table: "calendar_profiles",
    idPrefix: "calprofile",
    label: "Calendar Profiles",
    coreFields: ["name", "advance_notice_minutes", "booking_window_days", "active"] as const
  },
  {
    routeKey: "frequency-rules",
    table: "frequency_rules",
    idPrefix: "freq",
    label: "Frequencies",
    coreFields: ["name", "code", "discount_type", "discount_value", "active"] as const
  },
  {
    routeKey: "promotions",
    table: "promotions",
    idPrefix: "promo",
    label: "Discount Codes",
    coreFields: ["code", "name", "discount_type", "discount_value", "active"] as const
  },
  {
    routeKey: "lead-sources",
    table: "marketing_sources",
    idPrefix: "source",
    label: "Lead Sources",
    coreFields: ["name", "slug", "channel", "active"] as const
  },
  {
    routeKey: "notification-rules",
    table: "notification_rules",
    idPrefix: "notirule",
    label: "Notification Rules",
    coreFields: ["name", "event_key", "channel", "recipient_type", "active"] as const
  },
  {
    routeKey: "staff",
    table: "staff",
    idPrefix: "staff",
    label: "Staff",
    coreFields: ["first_name", "last_name", "email", "salary_method_id", "active"] as const
  },
  {
    routeKey: "staff-time-off",
    table: "staff_time_off",
    idPrefix: "staffoff",
    label: "Vacations",
    coreFields: ["staff_id", "start_date", "end_date"] as const
  },
  {
    routeKey: "tags",
    table: "tags",
    idPrefix: "tag",
    label: "Tags",
    coreFields: ["entity_type", "name", "color", "active"] as const
  },
  {
    routeKey: "salary-methods",
    table: "salary_methods",
    idPrefix: "salary",
    label: "Salary Methods",
    coreFields: ["name", "method_type", "active"] as const
  },
  {
    routeKey: "staff-types",
    table: "staff_types",
    idPrefix: "stafftype",
    label: "Staff Types",
    coreFields: ["name", "code", "directory_category", "display_order", "active"] as const
  }
] as const;

export const demoSeedIds = {
  accountId: "acct_demo",
  ownerUserId: "user_owner_demo",
  locationId: "loc_downtown_demo",
  serviceStandardId: "svc_standard_clean_demo",
  serviceDeepId: "svc_deep_clean_demo",
  bookingSpotId: "spot_downtown_team_a",
  salaryMethodId: "salary_hourly_demo",
  staffId: "staff_ana_demo",
  customerId: "cust_morgan_demo",
  bookingId: "booking_demo_one",
  promotionId: "promo_welcome10_demo",
  marketingSourceId: "source_website_demo"
} as const;
